// 员工档案 接口相关
import request from "../../untils/request.js"


export const getSupplierPayableAmountRecordPage = (params) => {
    return request.get("/outpatient/supplier/page", {params} )
}

export const supplierPayableAmountRecordManualOtherPurchases= (data) => {
    return request.post("/outpatient/supplier/purc", data )
}

export const supplierPayableAmountRecordManualPayments = (data) => {
    return request.post("/outpatient/supplier", data )
}

export const getSupplierPayableAmountRecordPayMentRecord = (params) => {
    return request.get("/outpatient/supplier/payList", {params} )
}

export const supplierPayableAmountPage = (params) => {
    return request.get("/outpatient/supplier/payPage", {params} )
}